import * as React from "react";
import { SVGProps, memo } from "react";

const BxBxChevronUp = (props: SVGProps<SVGSVGElement> & { slot?: string }) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.293 13.293L7.707 14.707L12 10.414L16.293 14.707L17.707 13.293L12 7.586L6.293 13.293Z" fill="currentColor" /></svg>;

const Memo = memo(BxBxChevronUp);
export default Memo;